import { Form } from '@anytag/shared-atoms';
import { TikTokSettingsFormSchema } from './schema';
import { Template, TikTokSettingsTemplateFormProps } from './Template';
import { TikTokSettingsFormProps } from './types';
import { defaultTikTokSettingsFormValues, getTikTokSettingsFormValues } from './utils';

export const TikTokSettingsForm = ({
  onSubmit,
  className,
  onOpenPasswordModal,
  defaultValues = defaultTikTokSettingsFormValues
}: TikTokSettingsFormProps & TikTokSettingsTemplateFormProps) => (
  <Form.Provider
    onSubmit={onSubmit}
    zodSchema={TikTokSettingsFormSchema}
    defaultValues={defaultValues}
    className={className}
  >
    <Template onOpenPasswordModal={onOpenPasswordModal} />
  </Form.Provider>
);

export { type TikTokSettingsFormProps, getTikTokSettingsFormValues };
